import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Stack, Tooltip } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { SubmitHandler, useForm } from "react-hook-form";
import z from "zod";

import { useSaveTruckBrandMutation } from "@/store";

import { Input } from "../../_Input";

type Schema = z.infer<typeof schema>;
const schema = z.object({
  id: z.number().optional(),
  brand: z.string().min(2, "Mínimo de 2 caracteres").max(100, "Máximo de 100 caracteres")
});

type CreateEditTruckBrandModalProps = {
  id?: number;
  brand?: string;
};
export function CreateEditTruckBrandModal({ id, context, innerProps }: ContextModalProps<CreateEditTruckBrandModalProps>) {
  const { id: innerId, brand } = innerProps;
  const [saveEditBrand] = useSaveTruckBrandMutation();

  const {
    handleSubmit,
    reset,
    control,
    formState: { isSubmitting, isDirty }
  } = useForm({
    mode: "all",
    resolver: zodResolver(schema),
    defaultValues: {
      id: innerId,
      brand: brand || ""
    }
  });

  const onSubmit: SubmitHandler<Schema> = async (data) => {
    const body = Object.assign({}, { name: data.brand }, innerId && { id: data.id });
    await saveEditBrand(body);

    handleDeny();
  };

  const handleDeny = () => {
    context.closeModal(id);
    reset();
  };

  return (
    <Stack>
      <Input.Text label="Marca" placeholder="Digite a marca do caminhão" control={control} name="brand" withAsterisk />

      <div className="grid grid-cols-1 gap-[inherit] md:grid-cols-2">
        <Button variant="default" onClick={handleDeny} disabled={isSubmitting}>
          Cancelar
        </Button>

        <Tooltip label="Nenhuma alteração detectada!" color="red" disabled={!isDirty}>
          <Button onClick={handleSubmit(onSubmit)} loading={isSubmitting} disabled={!isDirty} color={innerId ? "blue" : "green"}>
            {innerId ? "Salvar Alterações" : "Salvar"}
          </Button>
        </Tooltip>
      </div>
    </Stack>
  );
}
